import React, { useContext } from 'react'
import { ProgressWrapperProps, GlobalCtx } from './../interfaces'
import GlobalContext from "./../context/Global.ts";

const ProgressWrapper = (props: ProgressWrapperProps) => {
    const { progressWrapperStyles } = useContext<GlobalCtx>(GlobalContext);

    return (
        <div style={{
            ...styles.progress, 
            ...progressWrapperStyles, 
            ...getProgressWrapperStyle(props) 
        }}>
            {props.children}
        </div>
    )
}

const getProgressWrapperStyle = ({ width }) => ({
    width: `${width * 100}%`,
})

const styles = {
    progress: {
        height: 1,
        maxWidth: '100%',
        background: '#D5D1C9',
        margin: "0px 2px",
        borderRadius: 2,
        WebkitBackfaceVisibility: 'hidden' as const,
        MozBackfaceVisibility: 'hidden' as const,
        msBackfaceVisibility: 'hidden',
        backfaceVisibility: 'hidden' as const,
    }
}

export default ProgressWrapper